import type { InjectionKey } from 'vue';

/**
 * AFF (ABAX Frontend Federation) MFE-scope contract — CANONICAL DEFINITION.
 *
 * `@abax/platform` owns these: they are federation + host-boundary identifiers,
 * not design tokens. `AFF_SCOPE_KEY` is the GLOBAL `Symbol.for('abax-aff:scope')`
 * and the attributes are fixed string literals, so any other layer that needs
 * them (`@abax/ui`, MFEs) restates the same `Symbol.for` / strings locally and
 * gets identical values with NO dependency on this package — the values are the
 * contract, not this module. Keep cross-layer copies in lockstep with these.
 */

/** Provide/inject key carrying the active MFE's federation scope slug. */
export const AFF_SCOPE_KEY: InjectionKey<string> = Symbol.for('abax-aff:scope');

/** DOM attribute stamping the federation scope slug onto the cascade root. */
export const AFF_SCOPE_ATTR = 'data-mfe' as const;

/** DOM attribute marking the AFF preflight boundary on the same root. */
export const AFF_PREFLIGHT_ATTR = 'data-aff' as const;

/**
 * Well-known id of the host portal sink. `installAffHost` / `ensureAffPortalRoot`
 * create and own `#aff-portal-root`, `AffTeleport` teleports into it, and both
 * the shell layout and `@abax/ui`'s `usePortalTarget` resolve the same id. A
 * contract constant, so it lives here with the scope/boundary attributes rather
 * than in the host-implementation module.
 */
export const AFF_PORTAL_TARGET_ID = 'aff-portal-root' as const;
